export const getMediaQueries = (state) => state.session.responsive;
